import { render, staticRenderFns } from "./manage-bilan-sante.html?vue&type=template&id=b28bf782&scoped=true&external"
import script from "./manage-bilan-sante.js?vue&type=script&lang=js&external"
export * from "./manage-bilan-sante.js?vue&type=script&lang=js&external"
import style0 from "./manage-bilan-sante.scss?vue&type=style&index=0&id=b28bf782&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28bf782",
  null
  
)

export default component.exports